import { FilterBase } from '@myapp/modules/forms/models';

export class InstanceFilter extends FilterBase {

  GetFilter(inputValue: string) {
    return {
      filter: {
        logic: "or",
        filters: [
          {
            field: "clientName",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "oktaClientId",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "gxURL",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "gxKey",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "gxPassword",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "powerBIURL",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "databaseConnectionString",
            operator: "contains",
            value: inputValue,
          },
        ],
      },
    };
  }

}
